import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Button from "components/Button";

import PageNetBackground from "components/PageNetBackground";

import IbanQrErrorImg from "assets/images/iban-qr-error-img.png";
import { ReactComponent as IbanLogo } from "assets/images/iban_oplata-logo.svg";

import { routes } from "routes/routes";

import { styles } from "./styles";

interface ErrorPageProps {
  image?: string;
  message?: string | null;
  subMessage?: string | null;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  image,
  message,
  subMessage,
}) => {
  const errorMessage = message || "На жаль, сталась помилка.";
  const errorSubMessage =
    subMessage || "Будь ласка, спробуйте ще раз або зв’яжіться з підтримкою.";

  const onNavigateHome = () => {
    window.location.replace(routes.root);
  };

  return (
    <PageNetBackground sx={styles.errorPage}>
      <Box sx={styles.children}>
        <Box sx={styles.content}>
          <Box display="flex" alignItems="center" mb={2}>
            <IbanLogo
              style={{ cursor: "pointer" }}
              onClick={() => window.open(routes.ibanOplata, "_blank")}
            />
            <Typography sx={{ ml: 1.5 }}>IBAN oplata</Typography>
          </Box>
          <Box
            component="img"
            alt="error-img"
            src={image || IbanQrErrorImg}
            sx={styles.mobileImg}
          />
          <Typography variant="h2" sx={{ mb: 2, ...styles.textOverflow }}>
            {errorMessage}
          </Typography>
          <Typography color="grey800" sx={{ mb: 3, ...styles.textOverflow }}>
            {errorSubMessage}
          </Typography>
          <Button variant="contained" onClick={onNavigateHome}>
            Повернутись на головну
          </Button>
        </Box>
        <Box
          component="img"
          alt="error-img"
          src={image || IbanQrErrorImg}
          sx={styles.desktopImg}
        />
      </Box>
    </PageNetBackground>
  );
};

export default ErrorPage;
